const animationExpanded: any = {
  opacity: 1,
  transform: "translateX(232px)",
  position: "absolute",
  width: "240px",
  top: "0",
  zIndex: "-1",
  height: "100%",

  transition: {
    transform: { delay: 0, duration: 0.3, ease: "easeInOut" },
  },
};

const animationExpandCollapsed: any = {
  opacity: 1,
  transform: "translateX(232px)",
  position: "absolute",
  width: "240px",
  top: "0",
  zIndex: "-10",
  height: "100%",
  transition: "none",
};

const animationCollapsed: any = {
  opacity: 1,
  transform: "translateX(0px)",
  position: "absolute",
  width: "240px",
  top: "0",
  zIndex: "-10",
  height: "100%",
  transition: {
    transform: { delay: 0, duration: 0.3, ease: "easeInOut" },
  },
};

const animationExpandedMobile: any = {
  opacity: 1,
  transform: "translateX(100%)",
  marginLeft: -8,
  position: "absolute",
  width: "100%",
  top: "0",
  zIndex: "100",
  height: "100%",
};

const animationCollapsedMobile: any = {
  opacity: 1,
  transform: "translateX(100%)",
  marginBottom: 0,
  position: "absolute",
  width: "100%",
  top: "0",
  height: "100%",
  transition: {
    transform: { delay: 0, duration: 0.3, ease: "easeInOut" },
  },
};

const animationCollapsedTablet: any = {
  opacity: 1,
  transform: "translateX(0px)",
  position: "absolute",
  width: "240px",
  top: "0",
  zIndex: "-10",
  height: "100%",
  transition: "none",
  display: "none",
};

const navigationContextInitValues = {
  expandMenuOnMobile: null,
  openSubMenu: null,
  showSubMenu: null,
  setShowSubMenu: null,
  setNavItems: null,
  navItems: null,
  closeSubNav: null,
  reviewInsightsVisible: null,
};

export {
  animationCollapsed,
  animationExpanded,
  animationCollapsedMobile,
  animationExpandedMobile,
  navigationContextInitValues,
  animationExpandCollapsed,
  animationCollapsedTablet,
};
